import { render } from "./ControlCenter.vue?vue&type=template&id=25408ed4&scoped=true&ts=true"
import script from "./ControlCenter.vue?vue&type=script&lang=ts"
export * from "./ControlCenter.vue?vue&type=script&lang=ts"

import "./ControlCenter.vue?vue&type=style&index=0&id=25408ed4&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25408ed4"]])

export default __exports__